export interface CountryCode {
  id: string;
  value: string;
  label: string;
}

export const countriyCodes: CountryCode[] = [
  {
    id: 'AX',
    label: '+358&nbsp;&nbsp;&nbsp;Aland Islands',
    value: '358',
  },
  {
    id: 'AL',
    label: '+355&nbsp;&nbsp;&nbsp;Albania',
    value: '355',
  },
  {
    id: 'AD',
    label: '+376&nbsp;&nbsp;&nbsp;Andorra',
    value: '376',
  },
  {
    id: 'AR',
    label: '+54&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Argentina',
    value: '54',
  },
  {
    id: 'AT',
    label: '+43&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Austria',
    value: '43',
  },
  {
    id: 'BE',
    label: '+32&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Belgium',
    value: '32',
  },
  {
    id: 'BR',
    label: '+55&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Brazil',
    value: '55',
  },
  {
    id: 'BG',
    label: '+359&nbsp;&nbsp;&nbsp;Bulgaria',
    value: '359',
  },
  {
    id: 'CL',
    label: '+56&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Chile',
    value: '56',
  },
  {
    id: 'CO',
    label: '+57&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Colombia',
    value: '57',
  },
  {
    id: 'HR',
    label: '+385&nbsp;&nbsp;&nbsp;Croatia',
    value: '385',
  },
  {
    id: 'CY',
    label: '+357&nbsp;&nbsp;&nbsp;Cyprus',
    value: '357',
  },
  {
    id: 'CZ',
    label: '+420&nbsp;&nbsp;&nbsp;Czech Republic',
    value: '420',
  },
  {
    id: 'DK',
    label: '+45&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Denmark',
    value: '45',
  },
  {
    id: 'EC',
    label: '+593&nbsp;&nbsp;&nbsp;Ecuador',
    value: '593',
  },
  {
    id: 'SV',
    label: '+&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El Salvador',
    value: '',
  },
  {
    id: 'EE',
    label: '+372&nbsp;&nbsp;&nbsp;Estonia',
    value: '372',
  },
  {
    id: 'FO',
    label: '+298&nbsp;&nbsp;&nbsp;Faroe Islands',
    value: '298',
  },
  {
    id: 'FI',
    label: '+358&nbsp;&nbsp;&nbsp;Finland',
    value: '358',
  },
  {
    id: 'FR',
    label: '+33&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;France',
    value: '33',
  },
  {
    id: 'DE',
    label: '+49&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Germany',
    value: '49',
  },
  {
    id: 'GI',
    label: '+350&nbsp;&nbsp;&nbsp;Gibraltar',
    value: '350',
  },
  {
    id: 'GR',
    label: '+30&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Greece',
    value: '30',
  },
  {
    id: 'GL',
    label: '+299&nbsp;&nbsp;&nbsp;Greenland',
    value: '299',
  },
  {
    id: 'GT',
    label: '+502&nbsp;&nbsp;&nbsp;Guatemala',
    value: '502',
  },
  {
    id: 'GG',
    label: '+44&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Guernsey',
    value: '44',
  },
  {
    id: 'HU',
    label: '+36&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Hungary',
    value: '36',
  },
  {
    id: 'IS',
    label: '+354&nbsp;&nbsp;&nbsp;Iceland',
    value: '354',
  },
  {
    id: 'IN',
    label: '+91&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;India',
    value: '91',
  },
  {
    id: 'EI',
    label: '+353&nbsp;&nbsp;&nbsp;Ireland',
    value: '353',
  },
  {
    id: 'IT',
    label: '+39&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Italy',
    value: '39',
  },
  {
    id: 'JE',
    label: '+44&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jersey',
    value: '44',
  },
  {
    id: 'LV',
    label: '+371&nbsp;&nbsp;&nbsp;Latvia',
    value: '371',
  },
  {
    id: 'LI',
    label: '+423&nbsp;&nbsp;&nbsp;Liechtenstein',
    value: '423',
  },
  {
    id: 'LT',
    label: '+370&nbsp;&nbsp;&nbsp;Lithuania',
    value: '370',
  },
  {
    id: 'LU',
    label: '+352&nbsp;&nbsp;&nbsp;Luxembourg',
    value: '352',
  },
  {
    id: 'MT',
    label: '+356&nbsp;&nbsp;&nbsp;Malta',
    value: '356',
  },
  {
    id: 'MQ',
    label: '+&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Martinique',
    value: '',
  },
  {
    id: 'MU',
    label: '+&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mauritius',
    value: '',
  },
  {
    id: 'MX',
    label: '+52&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mexico',
    value: '52',
  },
  {
    id: 'MC',
    label: '+377&nbsp;&nbsp;&nbsp;Monaco',
    value: '377',
  },
  { id: 'NL', value: '31', label: '+31&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Netherlands' },

  { id: 'NZ', value: '64', label: '+64&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;New Zealand' },

  { id: 'NO', value: '47', label: '+47&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Norway' },

  { id: 'PA', value: '', label: '+&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Panama' },

  { id: 'PE', value: '51', label: '+51&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Peru' },

  { id: 'PL', value: '48', label: '+48&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Poland' },

  { id: 'PT', value: '351', label: '+351&nbsp;&nbsp;&nbsp;Portugal' },

  { id: 'RO', value: '40', label: '+40&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Romania' },

  { id: 'RU', value: '7', label: '+7&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Russian Federation' },

  { id: 'SM', value: '378', label: '+378&nbsp;&nbsp;&nbsp;San Marino' },

  { id: 'RS', value: '381', label: '+381&nbsp;&nbsp;&nbsp;Serbia' },

  { id: 'SG', value: '65', label: '+65&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Singapore' },

  { id: 'SK', value: '421', label: '+421&nbsp;&nbsp;&nbsp;Slovak Republic' },

  { id: 'SI', value: '386', label: '+386&nbsp;&nbsp;&nbsp;Slovenia' },

  { id: 'ES', value: '34', label: '+34&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Spain' },

  { id: 'SE', value: '46', label: '+46&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sweden' },

  { id: 'CH', value: '41', label: '+41&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Switzerland' },

  { id: 'GB', value: '44', label: '+44&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;United Kingdom' },

  { id: 'VE', value: '58', label: '+58&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Venezuela' },
];
